import { IS_PRODUCTION, TCHOP_ROOT_URL } from '../../env';
import { DeeplinkType } from '../components';
import { getOrganisationDomain } from './getOrganisationDomain';

interface DeepLinkUrlProps {
  type: DeeplinkType;
  channelId?: number;
  userId?: number;
  storyId?: number;
  cardId?: number;
  chatId?: number;
  eventId?: number;
  referralCode?: string;
}

export const getDeepLinkUrl = ({
  type,
  channelId,
  userId,
  storyId,
  cardId,
  chatId,
  eventId,
  referralCode,
}: DeepLinkUrlProps) => {
  if (!IS_PRODUCTION) {
    return '';
  }

  const { protocol = '', host = '' } = new URL(TCHOP_ROOT_URL ?? '');

  const appsPath = `${protocol}//${getOrganisationDomain().replace(/_/g, '')}.${host}/apps`;

  switch (type) {
    case DeeplinkType.CHANNEL:
      return `${appsPath}/channels/${channelId}`;
    case DeeplinkType.STORY:
      return `${appsPath}/stories/${channelId}/${storyId}`;
    case DeeplinkType.USER:
      return `${appsPath}/users/${channelId}/${userId}`;
    case DeeplinkType.CARD:
      return `${appsPath}/posts/${channelId}/${storyId}/${cardId}`;
    case DeeplinkType.DRAFT:
      return `${appsPath}/posts/${channelId}/${storyId}/${cardId}?draft=1`;
    case DeeplinkType.CHAT:
      return `${appsPath}/chats/${channelId}/${chatId}`;
    case DeeplinkType.REFERRAL:
      return `${appsPath}/signup/referral?c=${referralCode}`;
    case DeeplinkType.EVENT:
      return `${appsPath}/events/${channelId}/${eventId}`;
    case DeeplinkType.EVENT_DRAFT:
      return `${appsPath}/events/${channelId}/${eventId}?draft=1`;
    case DeeplinkType.BOOKMARKS:
      return `${appsPath}/bookmarks/${channelId}`;
    case DeeplinkType.EVENTS:
      return `${appsPath}/events/${channelId}`;
    case DeeplinkType.MY_TOPICS:
      return `${appsPath}/mytopics/${channelId}`;
    case DeeplinkType.PUSH_NOTIFICATIONS:
      return `${appsPath}/pushnotifications/${channelId}`;
    case DeeplinkType.NEWSLETTERS:
      return `${appsPath}/newsletters/${channelId}`;
    case DeeplinkType.USER_PROFILE:
      return `${appsPath}/userprofile/${channelId}`;
    case DeeplinkType.LEADERBOARD:
      return `${appsPath}/leaderboard/${channelId}`;
    default:
      return '';
  }
};
